module.exports = __webpack_public_path__ + "static/media/flashgbs-4.7deab296.jpg";